import React, { lazy, Suspense } from 'react';
import './ProfessionalMarketing.scss';

// Lazy load components
const ImageSlider = lazy(() => import('./tools/ImageSlider'));
const ProfessionalVideos = lazy(() => import('./ProfessionalVideos'));

const ProfessionalMarketing = () => {
  return (
    <section className="professional-marketing">
      <div className="container">
        <div className="heading">
          <h2>Professional Marketing Matters</h2>
          <p className="subtitle">
            Showcase your property in the best light with our expert marketing services.
          </p>
        </div>
        <div className="content">
          <div className="slideshow-container">
            {/* Suspense wraps the ImageSlider with a fallback for lazy loading */}
            <Suspense fallback={<div>Loading images...</div>}>
              <ImageSlider />
            </Suspense>
          </div>
          <div className="text-content">
            <h3>Professional Photography</h3>
            <p>
              Unlock your property's full potential with our high-impact professional photography. Stunning, high-quality images generate more interest and emphasize your property’s unique features, ensuring it stands out in the market.
            </p>
          </div>
        </div>
        <div className="content video-content">
          <div className="slideshow-container">
            {/* Suspense wraps the ProfessionalVideos with a fallback for lazy loading */}
            <Suspense fallback={<div>Loading video...</div>}>
              <ProfessionalVideos />
            </Suspense>
          </div>
          <div className="text-content">
            <h3>Professional Videos</h3>
            <p>
              Enhance your property's appeal with our professional video tours. High-quality videos offer an immersive experience, highlighting your property’s unique features and layout.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfessionalMarketing;
